import React, { FC } from "react";
import { PeopleIcon } from "@100mslive/react-icons";
import { Flex, Text } from "@100mslive/roomkit-react";

interface PresetCardProps {
  title: string;
  img: React.ReactNode;
  subText?: string;
  roles?: string;
  isActive: boolean;
  showRoles?: boolean;
  onClick: () => void;
}

const PresetCard: FC<PresetCardProps> = ({
  title,
  img,
  onClick,
  isActive,
  subText = "",
  roles = "", // < "listener, host" >
  showRoles = true,
}) => (
  <Flex
    direction="column"
    align="center"
    css={{
      backgroundColor: "$surface_default",
      border: "2px solid",
      borderColor: isActive ? "$primary_default" : "$border_default",
      borderRadius: "$0",
      px: "$md",
      py: "$14",
      cursor: "pointer",
      height: "216px",
      "&:hover": {
        backgroundColor: "$surface_bright",
      },
      "@media (max-width: 1440px)": {
        height: "100%",
      },
    }}
    onClick={onClick}
  >
    {img}
    <Text
      css={{
        mt: "$xs",
        fontWeight: "$semiBold",
        color: "$on_surface_high",
        textAlign: "center",
      }}
    >
      {title}
    </Text>
    {subText && (showRoles ? roles.length > 0 : true) ? (
      <Flex
        direction="column"
        justify="between"
        align="center"
        css={{ h: "100%" }}
      >
        <Text
          variant="xs"
          css={{
            color: "$on_surface_medium",
            textAlign: "center",
            mt: "$2",
            mb: showRoles ? "$12" : 0,
          }}
        >
          {subText}
        </Text>
        {showRoles ? (
          <Flex align="center" gap="1" css={{ color: "$on_surface_medium" }}>
            <PeopleIcon height={16} width={16} />
            <Text variant="xs" css={{ color: "$on_surface_medium" }}>
              {roles}
            </Text>
          </Flex>
        ) : null}
      </Flex>
    ) : null}
  </Flex>
);

export default PresetCard;
